<template>
  <card-item card="item_option" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Группа",
          component: () => import("./Group"),
        },
        {
          title: "Изображения",
          component: () => import("./Images"),
        },
        {
          title: "Описание",
          component: () => import("./Contents"),
        },
     
        {
          title: "Характеристики",
          component: () => import("./Features"),
        },
          {
          title: "Серийники",
          component: () => import("./Serials"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>